import React from 'react';
export function Hero() {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <section className="pt-24 pb-16" data-id="element-167">
      <h1 className="text-[36px] sm:text-[48px] md:text-[56px] font-bold text-[#1B2951] leading-tight mb-6 font-['Playfair_Display']" data-id="element-168">
        I Spent 2 Years Upgrading India's Favourite Collagen with this SUPER,
        SECRET Ingredient (And My Wife Says It's The Best Thing I've Ever Done)
      </h1>
      <h2 className="text-[20px] sm:text-[24px] text-[#2C3E50] mb-6 font-['Poppins'] font-medium" data-id="element-169">
        A personal letter from Nihaal Mariwala, Founder of Setu
      </h2>
      <div className="flex items-center text-[14px] text-[#7F8C8D] mb-8 font-['Inter']" data-id="element-170">
        <span data-id="element-171">Published: {currentDate}</span>
        <span className="mx-2" data-id="element-172">•</span>
        <span data-id="element-173">Read time: 8 min</span>
        <span className="mx-2" data-id="element-174">•</span>
        <span data-id="element-175">By: Nihaal Mariwala</span>
      </div>
      <div className="mb-8" data-id="element-176">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hXh7dsi6NVsnLbtjhc5h8g/u8357357769_Professional_photograph_of_elegant_French_female__fdf1ac1c-846a-4a35-9030-d4a64ca1d851_2.png" alt="Scientist in SEPPIC lab in Paris researching collagen formulations with the Eiffel Tower visible in the background" className="w-full rounded-lg shadow-md" data-id="element-177" />
      </div>
      <div className="w-full h-[1px] bg-[#FFB88C] opacity-30 mb-8" data-id="element-178"></div>
    </section>;
}